"use strict";

(function ($, root, undefined) {
  $(function () {
    "use strict";

    var contains = function contains(haystack, arr) {
      if (haystack.length) {
        return arr.some(function (v) {
          return haystack.indexOf(v) >= 0;
        });
      }

      return arr;
    };

    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
    window.addEventListener("resize", function () {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

      document.documentElement.style.setProperty("--vh", vh + "px");
    });
    var menuItem = $(".primary-navigation__list > li");

    function toggleMenuItemState(element) {
      element.toggleClass("active");
    }

    menuItem.mouseenter(function () {
      toggleMenuItemState($(this));
    });
    menuItem.mouseleave(function () {
      toggleMenuItemState($(this));
    });
    $("[data-fancybox]").fancybox({
      animationEffect: "fade"
    });
    $(".hamburger").click(function () {
      $(this).toggleClass("is-active");
      $(".primary-navigation").stop().toggleClass("active");
      $("body").toggleClass("disableScroll"); // $(".logo, footer, #content").toggleClass("blurContent");

      if ($(this).hasClass("is-active")) {
        setTimeout(function () {
          $("#menu-main-menu a").first().focus();
        }, 100);
      } else {// $("#content").focus();
      }
    });
    $(".search-icon").click(function (e) {
      e.preventDefault();
      $("#search-bar").addClass("active");
      $(".search-input").focus();
    });
    $(".search-reset").click(function (e) {
      e.preventDefault();
      $("#search-bar").removeClass("active");
    });
    $(function () {
      var istop = $("body");
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 40) {
          istop.removeClass("top").addClass("not-top");
          $("#header-top").addClass("scrolling");
        } else {
          istop.removeClass("not-top").addClass("top");
          $("#header-top").removeClass("scrolling");
        }
      });
    });
    $("#menu-main-menu a").last().keydown(function () {
      setTimeout(function () {
        $(".hamburger").focus();
      }, 0);
    });
    $(".owl-carousel").owlCarousel({
      loop: true,
      items: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      autoplayTimeout: 8000
    });
    $(".j-lazy-image").each(function () {
      var imgSrcUrl = $(this).data("src");
      var imgSrcSetUrl = $(this).data("srcset");
      $(this).waypoint(function () {
        if ($(this.element).attr("data-srcset")) {
          $(this).load(imgSrcSetUrl, function () {
            $(this.element).attr("srcset", imgSrcSetUrl).addClass("loaded");
          });
        }

        if ($(this.element).data("src")) {
          $(this).load(imgSrcUrl, function () {
            $(this.element).attr("src", imgSrcUrl).addClass("loaded");
          });
        }
      }, {
        offset: "90%"
      });
    });
    $(".j-lazy-bg").each(function () {
      var imgSrcUrl = $(this).data("src");
      var thumbImgSrcUrl = $(this).css("background-image");
      $(this).waypoint(function () {
        $(this).load(imgSrcUrl, function () {
          $(this.element).css({
            "background-image": "url(" + imgSrcUrl + "), " + thumbImgSrcUrl
          }).addClass("loaded");
        });
      }, {
        offset: "90%"
      });
    });
    $(".animate-block, .animate-custom").each(function () {
      $(this).waypoint(function () {
        $(this.element).addClass("animate");
      }, {
        offset: "100%"
      });
    });
    $("#footer-top__image-credits").on("click", function () {
      $(this).toggleClass("active");
      $("#footer-credits").slideToggle();

      if ($(this).hasClass("active")) {
        $("html, body").animate({
          scrollTop: $("#footer-credits").offset().top
        }, 800);
      }
    }); // Vue

    if ($("#projects-container").length) {
      new Vue({
        el: "#projects-container",
        data: {
          projectSearch: "",
          projects: projects,
          projectSectors: projectSectors,
          projectGeographies: projectGeographies,
          sort: {
            by: "title",
            order: "asc",
            options: {
              "A-Z": "asc",
              "Z-A": "desc"
            }
          },
          projectCategories: projectCategories,
          checkedProjectCategories: "",
          checkedProjectSectors: [],
          checkedProjectGeographies: [],
          currentPage: 1,
          itemsPerPage: 6,
          rangeStart: 0,
          totalItems: projects.length
        },
        computed: {
          rangeEnd: function rangeEnd() {
            var number = this.rangeStart + this.itemsPerPage;

            if (number >= this.totalItems) {
              number = this.totalItems;
            }

            return number;
          },
          pages: function pages() {
            return Math.ceil(this.totalItems / this.itemsPerPage);
          }
        },
        updated: function updated() {
          if (!this.checkedProjectCategories) {
            this.totalItems = projects.length;
          } else {
            this.totalItems = this.filteredProjects().length;
          }
        },
        methods: {
          setPage: function setPage(page) {
            this.currentPage = page;

            if (page == 1) {
              this.rangeStart = 0;
            } else {
              this.rangeStart = page * this.itemsPerPage - this.itemsPerPage;
            }
          },
          nextPage: function nextPage(event) {
            this.rangeStart = this.rangeEnd;
            this.currentPage += 1;
            if (this.rangeStart >= this.totalItems) this.rangeStart = this.rangeEnd - this.itemsPerPage;
            if (this.currentPage >= this.totalItems / this.itemsPerPage) this.currentPage = Math.ceil(this.totalItems / this.itemsPerPage);
          },
          previousPage: function previousPage(event) {
            this.rangeStart = this.rangeStart - this.itemsPerPage;
            this.currentPage -= 1;
            if (this.rangeStart <= 0) this.rangeStart = 0;
            if (this.currentPage <= 1) this.currentPage = 1;
          },
          filteredProjects: function filteredProjects() {
            var _this = this;

            if (this.projectSearch) {
              this.checkedProjectCategories = "";
              this.checkedProjectSectors = [];
              this.checkedProjectGeographies = [];
              return _.orderBy(projects.filter(function (project) {
                return project.title.match(RegExp(_this.projectSearch, "i"));
              }), this.sort.by, this.sort.order);
            } else {
              if (!this.checkedProjectCategories) {
                return _.orderBy(projects.filter(function (project) {
                  return contains(_this.checkedProjectSectors, project.sectors);
                }).filter(function (project) {
                  return contains(_this.checkedProjectGeographies, project.geographies);
                }), this.sort.by, this.sort.order);
              } else {
                return _.orderBy(projects.filter(function (project) {
                  return _.isEqual(_this.checkedProjectCategories, project.cat);
                }).filter(function (project) {
                  return contains(_this.checkedProjectSectors, project.sectors);
                }).filter(function (project) {
                  return contains(_this.checkedProjectGeographies, project.geographies);
                }).filter(function (project) {
                  return project.title.match(RegExp(_this.projectSearch, "i"));
                }), this.sort.by, this.sort.order);
              }
            }
          }
        }
      });
    }

    if ($("#updates-container").length) {
      new Vue({
        el: "#updates-container",
        data: {
          searchUpdates: "",
          updates: updates,
          currentPage: 1,
          itemsPerPage: 6,
          rangeStart: 0,
          totalItems: updates.length
        },
        computed: {
          rangeEnd: function rangeEnd() {
            var number = this.rangeStart + this.itemsPerPage;

            if (number >= updates.length) {
              number = updates.length;
            }

            return number;
          },
          pages: function pages() {
            return Math.ceil(updates.length / this.itemsPerPage);
          }
        },
        updated: function updated() {
          this.totalItems = this.filteredUpdates().length;
        },
        methods: {
          setPage: function setPage(page) {
            this.currentPage = page;

            if (page == 1) {
              this.rangeStart = 0;
            } else {
              this.rangeStart = page * this.itemsPerPage - this.itemsPerPage;
            }
          },
          nextPage: function nextPage(event) {
            this.rangeStart = this.rangeEnd;
            this.currentPage += 1;
            if (this.rangeStart >= updates.length) this.rangeStart = this.rangeEnd - this.itemsPerPage;
            if (this.currentPage >= updates.length / this.itemsPerPage) this.currentPage = Math.ceil(updates.length / this.itemsPerPage);
          },
          previousPage: function previousPage(event) {
            this.rangeStart = this.rangeStart - this.itemsPerPage;
            this.currentPage -= 1;
            if (this.rangeStart <= 0) this.rangeStart = 0;
            if (this.currentPage <= 1) this.currentPage = 1;
          },
          filteredUpdates: function filteredUpdates() {
            var _this2 = this;

            if (this.searchUpdates) {
              return updates.filter(function (update) {
                return update.title.match(RegExp(_this2.searchUpdates, "i"));
              });
            } else {
              return updates;
            }
          }
        }
      });
    }

    $(document.body).on("click", "#project-sectors-section > .title", function (e) {
      e.preventDefault();
      $(this).siblings("ul").toggleClass("d-flex");
      $(this).find("i").toggleClass("fa-rotate-90");
    });
    $(document.body).on("click", "#project-geography-section > .title", function (e) {
      e.preventDefault();
      $(this).siblings("ul").toggleClass("d-flex");
      $(this).find("i").toggleClass("fa-rotate-90");
    });
  });
})(jQuery, void 0);